import React, { useContext } from 'react';
import { Box, Typography } from '@mui/material';
import { FormDataContext } from '../../contexts/FormDataContext';

export const Banner = () => {
  const {
    intakeHeroImageUrl,
    intakeHeroOverlayHeading,
  } = useContext(FormDataContext);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' }, // Stack vertically on mobile, horizontally on larger screens
        height: { xs: 'auto', md: '500px' }, // Adjust height for mobile
        width: '100%',
        backgroundImage: { md: `url(${intakeHeroImageUrl})` }, // Show image as background on larger screens
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      {/* Hero Image */}
      <Box
        sx={{
          height: { xs: '50vh', md: '100%' }, // Responsive height
          width: '100%',
          backgroundImage: { xs: `url(${intakeHeroImageUrl})`, md: 'none' }, // Show image directly on mobile
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          display: { xs: 'block', md: 'none' }, // Hide on larger screens
        }}
      />
      {/* Text Content */}
      <Box
        sx={{
          display: 'flex',
          justifyContent: { xs: 'center', md: 'flex-start' }, // Center on mobile, align left on larger screens
          alignItems: 'center',
          p: { md: '40px', sm: 2 }, // Responsive padding
        }}
      >
        <Typography
          variant="h1"
          component="h1"
          dangerouslySetInnerHTML={{ __html: intakeHeroOverlayHeading }}
          sx={{
            textAlign: { xs: 'center', md: 'left' }, // Center on mobile, align left on larger screens
            mt: { xs: '20px', md: 0 }, // Margin top for mobile
          }}
        />
      </Box>
    </Box>
  );
};